import {
  ProductCardCompareLabelWeightsType,
  ProductCardMisureDiRischioType,
} from "types/AssistantTypes";
import { ProductTypeEnum } from "types/ProductTypes";

export const isValueZeroOrEmpty = (value: string | number): boolean => {
  return value === "-" || value === "0" || value === 0;
};

export const isProductBond = (productType: string): boolean => {
  return productType === ProductTypeEnum.BOND;
};

/**
 * Checks if all products in the comparison are bonds
 */
export const areAllProductsBonds = (
  productTypes: Record<string, string>,
): boolean => {
  return Object.values(productTypes).every(
    (type) => type === ProductTypeEnum.BOND,
  );
};

/**
 * Checks if any product in the comparison is a bond
 */
export const hasAnyBond = (productTypes: Record<string, string>): boolean => {
  return Object.values(productTypes).some(
    (type) => type === ProductTypeEnum.BOND,
  );
};

/**
 * Maps "-" values to "n.a." for bond products in misure di rischio data
 */
export const mapMisureDiRischioData = (
  data: ProductCardMisureDiRischioType[],
  productTypes: Record<string, string>,
  productIsins: string[],
): ProductCardMisureDiRischioType[] => {
  if (!hasAnyBond(productTypes)) return data;

  return data.map((item) => {
    return {
      ...item,
      product_values: item.product_values.map((value, index) => {
        const productIsin = productIsins[index];
        const isBond = isProductBond(productTypes[productIsin]);
        return isBond && isValueZeroOrEmpty(value) ? "n.a." : value;
      }),
      category_values: item.category_values.map((value, index) => {
        const productIsin = productIsins[index];
        const isBond = isProductBond(productTypes[productIsin]);
        return isBond && isValueZeroOrEmpty(value) ? "n.a." : value;
      }),
    };
  });
};

/**
 * Maps "-" values to "n.a." for bond products in settoriale data
 */
export const mapSettorialeData = (
  data: ProductCardCompareLabelWeightsType[],
  productTypes: Record<string, string>,
  productIsins: string[],
): ProductCardCompareLabelWeightsType[] => {
  if (!hasAnyBond(productTypes)) return data;

  return data.map((item) => ({
    ...item,
    weights: item.weights.map((value, index) => {
      const productIsin = productIsins[index];
      const isBond = isProductBond(productTypes[productIsin]);
      return isBond && isValueZeroOrEmpty(value) ? "n.a." : value;
    }),
  }));
};
